// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2tuGp","alert":"SettungsInbox_alert__3AaA2"};